import { InjectionToken } from "@angular/core";
import { IAppSwitcherModalService } from "./i-app-switcher-modal.service";

export const appSwitcherModalServiceInjectionToken: InjectionToken<IAppSwitcherModalService> =
  new InjectionToken<IAppSwitcherModalService>("IAppSwitcherModalService");
